<template>
    <div>
      <Loading/>
      <span><strong> {{listagem}} </strong></span>
        <form class="myForm mt-5" >
            <div class="form-group row">
                <label for="nome" class="col-sm-2 col-form-label">Tipo Unidade</label>
                <div class="col-sm-2">
                  <multiselect v-model="filTipoUni" tag-placeholder="Selecione" placeholder="Tipo Unid." label="" track-by="" select-label="" deselect-label="X" selectedLabel="" :options="tipoUnidades" @tag="addTag" @input="contasValor" @remove="contasValor"><span slot="noResult" class="text-info">Tipo não encontrada</span></multiselect>

                </div>
                <label for="nome" class="col-sm-2 col-form-label">Unidade</label>
                <div class="col-sm-2">
                  <multiselect v-model="filUnidade" tag-placeholder="Selecione" placeholder="Unidades" label="" select-label="" deselect-label="X" selectedLabel="" track-by="" :options="unidades" @tag="addTag" @input="contasValor" @remove="contasValor"><span slot="noResult" class="text-info">Unid. não encontrada</span></multiselect>
                </div>

                <label for="nome" class="col-sm-2 col-form-label">Fornecedor</label>
                <div class="col-sm-2">
                  <multiselect v-model="filFornecedor" tag-placeholder="Selecione" placeholder="Fornecedor" label="" select-label="" deselect-label="X" selectedLabel="" track-by="" :options="fornecedores" @tag="addTag" @input="contasValor" @remove="contasValor"><span slot="noResult" class="text-info">Forn. não encontrado</span></multiselect>
                </div>
            </div>

            <div class="form-group row">
                <label for="nome" class="col-sm-2 col-form-label">Tipo Fornecimento</label>
                <div class="col-sm-2">
                    <multiselect v-model="filTipoForn" tag-placeholder="Selecione" placeholder="Tipo Forn." label="" track-by="" select-label="" deselect-label="X" selectedLabel="" :options="tipoFornecimento" @tag="addTag" @input="contasValor" @remove="contasValor"><span slot="noResult" class="text-info">Tipo não encontrado</span></multiselect>
                </div>
                <label for="nome" class="col-sm-2 col-form-label">Mês Ref.</label>
                <div class="col-sm-2">
                  <multiselect v-model="filMesRef" tag-placeholder="Selecione" placeholder="Mes Ref." label="" track-by="" select-label="" deselect-label="X" selectedLabel="" :options="optionsMes" @tag="addTag" @input="contasValor" @remove="contasValor"><span slot="noResult" class="text-info">Mês não encontrado</span></multiselect>
                </div>

                <label for="nome" class="col-sm-2 col-form-label">Ano Ref.</label>
                <div class="col-sm-2">
                  <multiselect v-model="filAnoRef" tag-placeholder="Selecione" placeholder="Ano Ref." label="" track-by="" select-label="" deselect-label="X" selectedLabel="" :options="optionsAno" @tag="addTag" @input="contasValor" @remove="contasValor"><span slot="noResult" class="text-info">Ano não encontrado</span></multiselect>

                </div>
            </div>
        </form>
        <div :hidden="widget" class="row text-center mt-5">
          <div class="col-3 ml-4 mr-5">
              <button type="button" class="btn btn-info widgets">
                <p>Total de Contas</p>
                  <span class="badge badge-light p-3" id="dashboardTotal">{{totalContas}}</span>
              </button>
          </div>
          <div class="col-3 mr-5">
              <button type="button" class="btn btn-success widgets" @click="cliqueContaRec">
                <p>Contas Recebidas</p>
                <div :hidden="contRec">
                  <span class="badge badge-light p-3">{{contaReceb}}</span>
                </div>
                <div :hidden="contReceb">
                  <span class="badge badge-light p-3" id="dashboard"></span>
                </div>
              </button>
          </div>
          <div class="col-3">
              <button type="button" class="btn btn-danger widgets" @click="cliqueContaFalt">
                <p>Contas Faltantes</p>
                  <span class="badge badge-light p-3" id="dashboardFal"></span>
              </button>
          </div>
        </div>
        <div>
        <div :hidden="faltan">
          <div style="height:700px;">
            <div id="gridbox2" style="min-width:100%; height:100%; background-color:white;"></div>
          </div>
          <div class="container text-right mt-2 mb-2">
              <button class="btn btn-sm btn-danger" @click="retorno">Retornar</button>
          </div>
        </div>

      </div>

        <div :hidden="relatorio">
          <div :is="componente" ref="filho" class="mt-5"></div>

          <div class="container text-right mt-2">
            <button class="btn btn-sm btn-danger" @click="retorno">Retornar</button>
          </div>
        </div>
    </div>

</template>

<script>
import Loading from '@/components/Loading'
import Relatorio from '../relatorio/Relatorio'
import Multiselect from 'vue-multiselect'

export default {
  name: 'Dashboard',
  components: {
    Loading,
    Relatorio
  },
  components: {
     Multiselect,
      Loading
  },
  data () {
      return {
        listagem: 'DASHBOARD',
        componente: Relatorio,
        relatorio: true,
        widget: false,
        paginaTop: '',
        mes: '',
        ano: '',
        anosCombo: [],
        anos: [],
        contaFalt: '',
        contaReceb: '',
        conta: '',
        gridContas: '',
        contRec: false,
        contReceb: true,
        contFal: false,
        contFaltan: true,
        gridCadastroConta: '',
        unidades: [],
        faltan: true,
        tipoUnidades: [],
        fornecedores: [],
        tipoFornecimento: [],
        filTipoUni: '',
        filUnidade: '',
        filFornecedor: '',
        filTipoForn: [],
        filMesRef: new Date().getMonth() + 1,
        optionsAno: [],
        filAnoRef: new Date().getFullYear(),
        optionsMes: [],
        optionsTipoFor: [],
        totalContas: '',
        carregarTotal: false
      }
  },
  methods: {
    cliqueContaRec(){
      this.relatorio = false
      this.listagem = 'RELATÓRIO'
      this.widget = true
    },
    cliqueContaFalt(){
      this.faltan = false
      this.widget = true
    },
    contasVenc() {
      this.conta = 'recebidas'
      var forn = this.filFornecedor
      var tpuni = this.filTipoUni
      var uni = this.filUnidade
      var tipoforne = this.filTipoForn
      var mesRef = this.filMesRef
      var anoRef = this.filAnoRef

      this.$refs.filho.dhtmlx(this.conta, forn, tpuni, uni, tipoforne, mesRef, anoRef)

    },
    retorno() {
      this.$router.go(0);
    },
    contasValor(){
      this.contasVenc()
      this.criaContasFaltantes()
      this.contRec = true
      this.contReceb = false
       let recebidas = $('#dashboard').val();

    },
    renderizaTotal(){
      let totalRecebidos = $('#dashboard').html();
      let totalFaltantes = $('#dashboardFal').html();

      if(this.carregarTotal){
          this.carregarTotal = false
          this.totalContas = parseInt(totalRecebidos) + parseInt(totalFaltantes)
        }else {
          this.carregarTotal = true
      }
    },
    criaContasFaltantes(){
      api.enviarRequisicao('get', '/api/contas-consumo/contratos/faltantes/dhtmlx')
        .then(response => {
          let mesf = this.filMesRef
          this.gridCadastroConta.parse(response.data, "json")
          this.gridCadastroConta.filterBy(4, this.filFornecedor)
          this.gridCadastroConta.filterBy(1, this.filTipoUni, true)
          this.gridCadastroConta.filterBy(2, this.filUnidade, true)
          this.gridCadastroConta.filterBy(3, this.filTipoForn, true)
          this.gridCadastroConta.filterBy(9, function(data){
            if(mesf == null){
              return true;
            } else {
              return data == mesf;
            }
          }, true)
          this.gridCadastroConta.filterBy(10, this.filAnoRef, true)
          this.renderizaTotal()
        });

      this.gridCadastroConta = new dhtmlXGridObject("gridbox2");
      this.gridCadastroConta.setImagePath("libs/imgs/");
      this.gridCadastroConta.setHeader("Codigo,Tipo Unidade, Unidade, Tipo Fornecimento, Fornecedor, Contrato, Data de Venc., Consumo, Valor, Mes Ref, Ano Ref, Contrato Id");
      this.gridCadastroConta.setInitWidths("10,90,200,90,110,200,100,80,90,90,90,190");
      this.gridCadastroConta.setColAlign("center,left,left,left,left,left,left,left,left,left,left,left");
      this.gridCadastroConta._in_header_stat_count(document.getElementById('dashboardFal'),1,[]);
      this.gridCadastroConta.setColTypes("ro,ro,ro,ro,ro,ro,ro,ro,ro,ro,ro,edn");
      this.gridCadastroConta.setColSorting("int,str,str,str,str,str,str,str,str,int,str,str");
      this.gridCadastroConta.setColumnHidden(0,true);
      this.gridCadastroConta.setColumnHidden(6,true);
      this.gridCadastroConta.setColumnHidden(7,true);
      this.gridCadastroConta.setColumnHidden(8,true);
      // this.gridCadastroConta.setColumnHidden(10,true);
      this.gridCadastroConta.setColumnHidden(11,true);
      this.gridCadastroConta.setNumberFormat("0,000,000,000.00",8);
      this.gridCadastroConta.init();
      // this.gridCadastroConta.enableSmartRendering(true,50);
    },

    addTag (newTag) {
        this.filAnoRef.push(newTag)
        this.contasValor()
      }
  },
  mounted: function(){
    api.enviarRequisicao('get', '/api/contas-consumo/tipo-unidades')
      .then(response => {
        for(let i = 0; i < response.data.length; i++){
          this.tipoUnidades.push(response.data[i].tp00_descricao)
        }
    });
    api.enviarRequisicao('get', '/api/contas-consumo/unidades')
      .then(response => {
        for(let i = 0; i < response.data.length; i++){
          this.unidades.push(response.data[i].ba02_unidade)
        }
    });
    api.enviarRequisicao('get', '/api/contas-consumo/fornecedores')
      .then(response => {
        for(let i = 0; i < response.data.length; i++){
          this.fornecedores.push(response.data[i].ba00_fornecedor)
        }
    });
    api.enviarRequisicao('get', '/api/contas-consumo/tipo-fornecimentos')
      .then(response => {
        for(let i = 0; i < response.data.length; i++){
          this.tipoFornecimento.push(response.data[i].tp01_descricao)
        }
    });

    this.criaContasFaltantes()

    api.enviarRequisicao('get', '/api/contas-consumo/contratos/recebidos/count/dhtmlx')
      .then(response => {
        this.contaReceb = response.data[0].count_cadastro_contas
    });

    let i = 2000
    let mes = 1

    while(new Date().getFullYear() >= i)
    {
      this.anosCombo.push(i)
      i++
    }
    this.optionsAno = this.anosCombo.slice().reverse()

    while(mes <= 12){
      this.optionsMes.push(mes)
      mes++
    }

    this.contasValor()


  }


}

</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>

a {
  background-color: #18A689;
  color: #fff;
  font-size: 12px;
  text-decoration: none;
}

.widgets {
  min-width: 250px;
  min-height: 150px;
}

</style>
